<template >
    <div class="container-fluid" v-if="user">
        <v-btn @click="$router.go(-1)" outlined style="border: none;margin-right: 10px" title="Retour"><v-icon>mdi mdi-arrow-left</v-icon></v-btn>
        <v-row>
            <v-col cols="3">
                  <img class="circular--square" id="profil-image" v-lazy="'/'+user.image.original" alt=""><br>
            </v-col>
             <v-col v-if="!user.role._code.includes('admin')" cols="3">
              <v-card style="padding: 15px;"  class="background-linear">
                  <div class="row">
                     <div class="col-md-12 pt-2 pb-0"><v-icon large >mdi-cash-multiple</v-icon></div>
                     <div class="col-md-12 ">
                         <div>Portefeuille : </div>
                         <div style="font-weight: bold">{{(user.wallet)?user.wallet._amount:'-'}} X0F</div>
                     </div>
                  </div>

              </v-card>
            </v-col>
            <v-col v-if="!user.role._code.includes('admin')" cols="3">
              <v-card style="padding: 15px"   class="background-linear">
                  <div class="row">
                      <div class="col-md-12 pt-2 pb-0"><v-icon large>mdi-clock</v-icon></div>
                      <div class="col-md-12 ">
                          <div>Comptes : </div>
                          <div  style="font-weight: bold">{{user.marchands.length}}</div>
                      </div>
                  </div>
              </v-card>
            </v-col>
            <!--<v-col cols="3">
              <v-card style="padding: 15px"  class="background-linear">
                  <div class="row">
                      <div class="col-md-12 pt-2 pb-0"><v-icon large>mdi-account-convert-outline</v-icon></div>
                      <div class="col-md-12 ">
                        <div>Initiateur : </div>
                        <div  style="font-weight: bold">{{(transaction.customer)?transaction.customer._first_name+' '+transaction.customer._last_name:'-'}}</div>
                      </div>
                  </div>
              </v-card>
            </v-col>-->
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-card>
                    <h4 style="padding: 18px;font-weight: bold" class="background-tb">Informations</h4>
                    <table style="width: 100%" class="p-3 table table-striped">
                        <tbody>
                        <tr style="padding: 15px" >
                            <td style="padding: 15px"> Nom:</td>
                            <td>{{user._last_name}}</td>
                        </tr>
                        <tr style="padding: 15px" >
                            <td style="padding: 15px"> Prénoms:	</td>
                            <td class="text-lowercase">{{user._first_name}}</td>

                        </tr>
                        <tr style="padding: 15px" >
                            <td style="padding: 15px"> Émail:</td>
                            <td>{{user._email}}</td>
                        </tr>
                        <tr style="padding: 15px" >
                            <td style="padding: 15px">Téléphone:</td>
                            <td>{{user._phone}}</td>
                        </tr>
                        <tr style="padding: 15px" >
                            <td style="padding: 15px"> Pays:</td>
                            <td>{{(user.country)?user.country._name:'-'}}</td>
                        </tr>
                        <tr style="padding: 15px" >
                            <td style="padding: 15px"> Rôle:</td>
                            <td>{{user.role._label}} </td>
                        </tr>
                        <tr style="padding: 15px" >
                            <td style="padding: 15px"> État du compte:</td>
                            <td>{{(user._active)?'actif':'inactif'}}</td>
                        </tr>
                        <tr style="padding: 15px" >
                            <td style="padding: 15px"> Date d'inscription:</td>
                            <td>{{getDate(user._created_at)}}</td>
                        </tr>
                        </tbody>
                    </table>
                </v-card>
            </v-col>
            <v-col cols="6">
                <v-card>
                    <h4 style="padding: 18px;font-weight: bold" class="background-tb">Actions récentes</h4>
                    <table style="width: 100%" class="p-3 table table-striped">
                        <tbody v-if="logs && logs.length>0">

                        <tr  style="padding: 15px" v-for="log in logs" :key="log._id">
                            <td style="padding: 15px" > {{$t(log._action)}}</td>
                            <td style="padding: 15px" > {{log._ip}}</td>
                            <td style="padding: 15px"> {{getDate(log._created_at)}}</td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                        <tr>
                            <td style="text-align: center">{{$t('no_recent_actions')}}</td>
                        </tr>
                        </tbody>
                    </table>
                </v-card>
            </v-col>

        </v-row>

        </div>
    <div v-else class="col-lg-12 col-md-12 col-12 text-center loader_panel_component">
        <img v-lazy="'/loaders/loader_turq.gif'" alt=""><br>
        <span class="loader_text"> Chargement en cours ... </span>
    </div>
</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from '../../mixins/helpers'
    import $ from 'jquery'

    $.fn.scrollToTop = function (speed) {
        if (typeof(speed) === 'undefined')
            speed = 1000;

        $('html, body').animate({
            scrollTop: parseInt($(this).offset().top)
        }, speed);
    };
    export default {
        label: "Transactions",
        mixins:[helpers(this)],
        data () {
            return {
                filter:'',
                date: new Date().toISOString().substr(0, 10),
                transactions_tabs:'',
                errors:{},
                search: '',
                dialog: '',
                id:undefined,

            }
        },
        computed: {

            ...mapState('users/',['user','logs'])
        },
        mounted(){
            if (this.$route.params.user_id){
                this.$store.dispatch('users/getUserAccountDetails',this.$route.params.user_id).then((result)=>{console.log('user',result)})
            }
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        methods: {
            getStatusColor(status){
                let response = {};
                switch (status) {
                    case process.env.VUE_APP_STATUS_ERROR:
                        response.color = 'red';
                        response.status = 'échec';
                        break;
                        case process.env.VUE_APP_STATUS_PENDING:
                            response.color = 'orange';
                            response.status = 'en attente';
                            break;
                            case process.env.VUE_APP_STATUS_SUCCESS:
                                response.color = 'success';
                                response.status = 'succès';
                                break;
                                default:
                                    response.color = 'dark';
                                    response.status = 'defaut';
                                    break;
                }
                return response;
            },
        },
        created() {
            this.checkisDashboard();
        },

    }
</script>

<style scoped>
    .circular--square {
        border-radius: 50%;
    }
    .circular--square {
        border-radius: 50% 50%;
        width: 170px;
        height: 170px;
        object-fit: contain;
    }
.action-inputs-group{
    margin-left: 1%;
}
    h2{
        color: #1C3071;
    }
    .actions-inputs{
        display: inline-block;
        margin: 15px;
    }
</style>
